import { Box, Text, Stat } from '.'

export default function SimpleStat ({ name, number, total, helpText, helpTextAsPercentage }) {
  return (
    <Stat
      label={name}
      value={
        <Box>
          <Text fontWeight='bold'>{number}</Text>
          {(helpText || helpTextAsPercentage) &&
            <Text>
              {helpText || `${((number / total) * 100).toFixed(2)}%`}
            </Text>}
        </Box>
}
    />
  )
}
